<mat-form-field id="search">
    <mat-label>Type to Search</mat-label>
    <input matInput [(ngModel)]="userSearchState" placeholder="User" />
</mat-form-field>

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 demo-table">
    @for (column of columns(); track column) {
        <ng-container [matColumnDef]="column.columnDef">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Sort by {{ column.header }}"
                [disabled]="column.type === 'action'">
                {{ column.header }}
            </th>

            <td mat-cell *matCellDef="let row; let index = index">
                @if (column.type === 'action') {
                    <button class="options" mat-button [matMenuTriggerFor]="optionsMenu" type="button">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #optionsMenu="matMenu">
                        @for (option of row.actions; track $index) {
                            @if (option.value) {
                                <button
                                    mat-menu-item
                                    (click)="clickOption.emit({ optionValue: option.value, id: row.id })"
                                    [attr.data-testid]="option.display"
                                    type="button">
                                    {{ option.display }}
                                </button>
                            }
                        }
                    </mat-menu>
                } @else {
                    @if (column.columnDef === 'divisions') {
                        {{ row[column.columnDef] | csv }}
                    } @else {
                        {{ row[column.columnDef] }}
                    }
                }
            </td>
        </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
</table>

<mat-paginator [pageSizeOptions]="[50, 10, 25]" showFirstLastButtons aria-label="Select page of users" />

<button mat-raised-button color="primary" id="add-user" (click)="addUser.emit()" type="button">+Add User</button>
